@if (permissionService.hasBaseAccess()) {
  <div class="sidebar-container">
    <div class="sidebar-header-row">
      @if (showInsuredCertificates()) {
        <div class="rail-header">
          <button class="rail-expand-button"
                  type="button"
                  data-test="insured-rail-expand-button"
                  title="Show all insured"
                  (click)="expandInsuredList()"
          >
            <i class="pi pi-chevron-right"></i>
          </button>
        </div>
      }

      <p-panel class="sidebar-panel"
               toggleable="true"
               [collapsed]="true"
               [header]="displayedContent()"
      >
        <ng-template #headericons
                     let-collapsed
        >
          <span [class]="collapsed ? 'pi pi-filter' : 'pi pi-filter-fill'"></span>
        </ng-template>
        <albert-listview-filter [contentType]="displayedContent()"/>
      </p-panel>
    </div>
    @let activeCat = categoryService.activeCategory();
    @if (showInsuredCertificates()) {
      <albert-listview-insured-certificates
        animate.enter="sidebar-view-collapse-enter"
        [insuredUuid]="selectedInsuredUuid()"
        [(sidebarDrawerVisible)]="sidebarDrawerVisible"
      />
    } @else if (listViewContent() === 'Insured' && permissionService.canView(activeCat)) {
      <albert-listview-insured
        animate.enter="sidebar-view-expand-enter"
        [selectedUuid]="selectedInsuredUuid()"
        [(sidebarDrawerVisible)]="sidebarDrawerVisible"
        (entrySelected)="collapseInsuredList()"
      />
    } @else if (listViewContent() === 'Content Units' && permissionService.hasRedactRights()) {
      <albert-listview-cu [(sidebarDrawerVisible)]="sidebarDrawerVisible"/>
    } @else if (listViewContent() === 'Templates' && permissionService.hasRedactRights()) {
      <albert-listview-template [(sidebarDrawerVisible)]="sidebarDrawerVisible"/>
    } @else if (listViewContent() === 'Certificate Holders') {
      <albert-listview-ch [(sidebarDrawerVisible)]="sidebarDrawerVisible"/>
    } @else if (listViewContent() === 'Certificates') {
      <albert-listview-insured
        animate.enter="sidebar-view-expand-enter"
        [selectedUuid]="selectedInsuredUuid()"
        [(sidebarDrawerVisible)]="sidebarDrawerVisible"
        (entrySelected)="collapseInsuredList()"
      />
    }
  </div>
}
